import React from "react";
import { useEffect, useState } from "react";
import axios from "axios";
import { Card, CardHeader, CardBody, Table } from "reactstrap";

interface SalesLeaderboardData {
  name: string;
  bookedRevenue: string;
  annualQuota: string;
  activePipeline: string;
  consultantsOnBilling: number; // Assuming this is a number, update if needed
}

const SalesTeamLeaderboard = () => {
  // Hardcoded data from your screenshot
  const [data, setData] = useState<SalesLeaderboardData[] | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get("/leaderboard-data");
      const results: SalesLeaderboardData[] = response.data.map((item: any) => {
        return {
          name: item.name || "",
          bookedRevenue: item.bookedRevenue || "",
          annualQuota: item.annualQuota || "",
          activePipeline: item.activePipeline || "",
          consultantsOnBilling: item.consultantsOnBilling || 0,
        };
      });
      setData(results);
      setLoading(false);
    } catch (err: any) {
      console.error("Error fetching data:", err);
      setError(err.message);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Card>
      <CardHeader>Sales Team Leaderboard</CardHeader>
      <CardBody>
        <Table bordered hover>
          <thead>
            <tr>
              <th>Name</th>
              <th>Booked Revenue</th>
              <th>Annual Quota (CY 2025)</th>
              {/* <th>Consultants on Billing</th> */}
            </tr>
          </thead>
          <tbody>
            {data &&
              data.map((row, idx) => (
                <tr key={idx}>
                  <td>{row.name}</td>
                  <td>{row.bookedRevenue}</td>
                  <td>{row.annualQuota}</td>
                  {/* <td>{row.consultantsOnBilling}</td> */}
                </tr>
              ))}
          </tbody>
        </Table>
      </CardBody>
    </Card>
  );
};

export default SalesTeamLeaderboard;
